// extracted by mini-css-extract-plugin
export var brand = "_2k-9";
export var compact = "_2k-6";
export var extraSmall = "_2k-7";
export var icon = "_2k-0";
export var large = "_2k-4";
export var light = "_2k-1";
export var medium = "_2k-5";
export var outline = "_2k-b";
export var primaryDark = "_2k-a";
export var primaryLight = "_2k-8";
export var primaryModern = "_2k-c";
export var success = "_2k-2";
export var successSolid = "_2k-3";